(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marbellasearch"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const CATALOG_KEY = 'leire_catalog_index_v1';
    const CATALOG_TTL = 60 * 60 * 1000;
    const catalogState = { loaded: false, loading: null, items: [] };

    /*
      Rango de caracteres de acentos (U+0300 a U+036F), para que el buscador
      ignore los acentos: "jersey" encuentra "jerséy".
      Se construye con String.fromCharCode y no con una secuencia \u escapada,
      porque al subir este fichero por la API esa secuencia se convertía en
      caracteres combinantes literales e invisibles. Así es ASCII puro y no se
      puede mangullar al copiar y pegar. El resultado es exactamente el mismo.
    */
    const LM_RANGO_ACENTOS = new RegExp(
      '[' + String.fromCharCode(768) + '-' + String.fromCharCode(879) + ']',
      'g'
    );

    function normalizeText(str) {
      return String(str || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(LM_RANGO_ACENTOS, '');
    }

    function toCents(value) {
      const n = parseFloat(value);
      return isNaN(n) ? 0 : Math.round(n * 100);
    }

    async function loadCatalog() {
      if (catalogState.loaded) return catalogState.items;
      if (catalogState.loading) return catalogState.loading;

      catalogState.loading = (async function() {
        try {
          const raw = sessionStorage.getItem(CATALOG_KEY);
          if (raw) {
            const parsed = JSON.parse(raw);
            if (parsed && parsed.t && (Date.now() - parsed.t) < CATALOG_TTL
              && Array.isArray(parsed.items) && parsed.items.length) {
              catalogState.items = parsed.items;
              catalogState.loaded = true;
              return parsed.items;
            }
          }
        } catch (e) {}

        const items = [];
        for (let page = 1; page <= 8; page++) {
          let batch = [];
          try {
            const res = await fetch('/products.json?limit=250&page=' + page, {
              headers: { 'Accept': 'application/json' }
            });
            if (!res.ok) break;
            const data = await res.json();
            batch = data.products || [];
          } catch (e) {
            break;
          }

          if (batch.length === 0) break;

          batch.forEach(function(p) {
            const variant = (p.variants && p.variants[0]) || {};
            const image = (p.images && p.images[0]) || null;
            items.push({
              t: p.title,
              u: '/products/' + p.handle,
              i: image ? image.src : '',
              p: toCents(variant.price),
              c: variant.compare_at_price ? toCents(variant.compare_at_price) : null,
              n: normalizeText(p.title)
            });
          });

          if (batch.length < 250) break;
        }

        catalogState.items = items;
        catalogState.loaded = true;
        try {
          sessionStorage.setItem(CATALOG_KEY, JSON.stringify({ t: Date.now(), items: items }));
        } catch (e) {}
        return items;
      })();

      return catalogState.loading;
    }

    function searchCatalog(term, limit) {
      const q = normalizeText(term);
      if (!q) return [];

      const starts = [];
      const wordStarts = [];
      const contains = [];

      for (let k = 0; k < catalogState.items.length; k++) {
        const it = catalogState.items[k];
        const idx = it.n.indexOf(q);
        if (idx === -1) continue;

        if (idx === 0) {
          starts.push(it);
        } else if (/[\s\-|·,.(\/]/.test(it.n.charAt(idx - 1))) {
          wordStarts.push(it);
        } else {
          contains.push(it);
        }
      }

      return starts.concat(wordStarts).concat(contains).slice(0, limit);
    }

    document.querySelectorAll('[data-mb-drawer]').forEach(initDrawer);

    function initDrawer(drawerRoot) {
      const backdrop = drawerRoot.querySelector('[data-mb-backdrop]');
      const closeBtn = drawerRoot.querySelector('[data-mb-close]');
      const clearTextBtn = drawerRoot.querySelector('[data-mb-clear-text]');
      const searchSection = drawerRoot.querySelector('[data-mb-search]');
      if (!searchSection) return;

      const form = searchSection.querySelector('[data-mb-form]');
      const input = searchSection.querySelector('[data-mb-input]');
      const idleBlock = searchSection.querySelector('[data-mb-idle]');
      const ssrResults = searchSection.querySelector('[data-mb-ssr-results]');
      const live = searchSection.querySelector('[data-mb-live]');
      const liveEmpty = searchSection.querySelector('[data-mb-live-empty]');
      const liveProducts = searchSection.querySelector('[data-mb-live-products]');
      const liveFoot = searchSection.querySelector('[data-mb-live-foot]');
      const liveAll = searchSection.querySelector('[data-mb-live-all]');
      const loadingEl = searchSection.querySelector('[data-mb-loading]');

      const historyBlock = searchSection.querySelector('[data-mb-history]');
      const historyList = searchSection.querySelector('[data-mb-history-list]');
      const historyClear = searchSection.querySelector('[data-mb-history-clear]');

      let debounceTimer;
      let currentQuery = '';

      const resultsLimit = parseInt(drawerRoot.getAttribute('data-mb-results-limit'), 10) || 6;
      const isSearchPage = drawerRoot.getAttribute('data-mb-search-page') === 'true';

      /* ---------- Sugerencias rotando en la barra (14/10/2026) ----------
         El texto gris de la barra va cambiando entre las sugerencias de los
         ajustes, para dar ideas de qué buscar.

         Tres cuidados:
           1. Solo rota con el cajón ABIERTO, y el intervalo se para al cerrarlo.
              Nada corriendo de fondo cuando no se ve (lección del bucle de /cart.js).
           2. Si el cliente tiene algo escrito no se toca el placeholder, porque
              ni se ve ni interesa moverlo.
           3. Al cerrar se devuelve el texto original, para no dejar la barra con
              una sugerencia pegada.
      */
      const rotateOn = drawerRoot.getAttribute('data-mb-rotate') === 'true';
      const rotateList = (drawerRoot.getAttribute('data-mb-suggestions') || '')
        .split(',')
        .map(function(t) { return t.trim(); })
        .filter(function(t) { return t.length > 0; });
      const placeholderBase = input ? (input.getAttribute('placeholder') || '') : '';
      let rotateTimer = null;
      let rotateIndex = 0;

      function stopRotate() {
        if (rotateTimer) { clearInterval(rotateTimer); rotateTimer = null; }
        if (input && placeholderBase) input.setAttribute('placeholder', placeholderBase);
      }

      function startRotate() {
        if (!rotateOn || !input || rotateList.length === 0 || rotateTimer) return;
        rotateTimer = setInterval(function() {
          if ((input.value || '').trim() !== '') return;
          input.setAttribute('placeholder', rotateList[rotateIndex % rotateList.length]);
          rotateIndex++;
        }, 2800);
      }

      /* ---------- Historial ---------- */
      const customerKey = drawerRoot.getAttribute('data-mb-customer') || 'guest';
      const isLoggedIn = drawerRoot.getAttribute('data-mb-logged-in') === 'true';
      const historyEnabled = drawerRoot.getAttribute('data-mb-history-enabled') === 'true';
      const historyLoggedOnly = drawerRoot.getAttribute('data-mb-history-logged-only') === 'true';
      const historyMax = parseInt(drawerRoot.getAttribute('data-mb-history-max'), 10) || 4;
      const historyKey = 'leire_search_history_' + customerKey;

      function historyAllowed() {
        if (!historyEnabled) return false;
        if (historyLoggedOnly && !isLoggedIn) return false;
        return true;
      }

      function readHistory() {
        if (!historyAllowed()) return [];
        try {
          const raw = localStorage.getItem(historyKey);
          const parsed = raw ? JSON.parse(raw) : [];
          return Array.isArray(parsed) ? parsed : [];
        } catch (e) {
          return [];
        }
      }

      function writeHistory(list) {
        try { localStorage.setItem(historyKey, JSON.stringify(list)); } catch (e) {}
      }

      function saveTerm(term) {
        if (!historyAllowed()) return;
        const clean = String(term || '').trim();
        if (clean.length < 2) return;
        let list = readHistory().filter(function(t) {
          return t.toLowerCase() !== clean.toLowerCase();
        });
        list.unshift(clean);
        if (list.length > historyMax) list = list.slice(0, historyMax);
        writeHistory(list);
        renderHistory();
      }

      function removeTerm(term) {
        const list = readHistory().filter(function(t) {
          return t.toLowerCase() !== String(term).toLowerCase();
        });
        writeHistory(list);
        renderHistory();
      }

      function renderHistory() {
        if (!historyBlock || !historyList) return;
        const list = readHistory();

        if (!historyAllowed() || list.length === 0) {
          historyBlock.hidden = true;
          historyList.innerHTML = '';
          return;
        }

        historyBlock.hidden = false;
        historyList.innerHTML = list.map(function(term) {
          return '<li><div class="mb-suggest__row">'
            + '<button type="button" class="mb-suggest__btn" data-mb-history-term="' + escapeHtml(term) + '">' + escapeHtml(term) + '</button>'
            + '<button type="button" class="mb-suggest__remove" data-mb-history-remove="' + escapeHtml(term) + '" aria-label="Quitar del historial">'
            + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>'
            + '</button>'
            + '</div></li>';
        }).join('');
      }

      if (historyClear) {
        historyClear.addEventListener('click', function() {
          writeHistory([]);
          renderHistory();
        });
      }

      if (historyList) {
        historyList.addEventListener('click', function(e) {
          const removeBtn = e.target.closest('[data-mb-history-remove]');
          if (removeBtn) {
            removeTerm(removeBtn.getAttribute('data-mb-history-remove'));
            return;
          }
          const termBtn = e.target.closest('[data-mb-history-term]');
          if (termBtn && input) {
            input.value = termBtn.getAttribute('data-mb-history-term');
            input.focus();
            currentQuery = '';
            handleInput();
          }
        });
      }

      /* ---------- Ocultar el resto de la página ---------- */
      let sectionWrapper = drawerRoot;
      while (sectionWrapper.parentElement && sectionWrapper.parentElement !== document.body) {
        sectionWrapper = sectionWrapper.parentElement;
      }

      function setSiblingsHidden(hide) {
        Array.prototype.forEach.call(document.body.children, function(el) {
          if (el === sectionWrapper) return;
          if (el.id === 'header-group') return;
          el.style.visibility = hide ? 'hidden' : '';
        });
      }

      /* En móvil/tablet el cajón es lateral (tipo carrito): la tienda se ve oscurecida detrás */
      function isMobileDrawer() {
        return !!(window.matchMedia && window.matchMedia('(max-width: 900px)').matches);
      }

      /* ---------- Abrir / cerrar ---------- */
      function openDrawer() {
        drawerRoot.classList.add('is-open');
        drawerRoot.setAttribute('aria-hidden', 'false');
        if (!isMobileDrawer()) setSiblingsHidden(true);
        document.body.style.overflow = 'hidden';
        renderHistory();
        loadCatalog();
        startRotate();
        setTimeout(function() { if (input) input.focus(); }, 350);
      }

      function closeDrawer() {
        stopRotate();

        if (isSearchPage) {
          if (document.referrer
            && document.referrer.indexOf(window.location.origin) === 0
            && document.referrer.indexOf('/search') === -1) {
            window.history.back();
          } else {
            window.location.href = '/';
          }
          return;
        }

        drawerRoot.classList.remove('is-open');
        drawerRoot.setAttribute('aria-hidden', 'true');
        setSiblingsHidden(false);
        document.body.style.overflow = '';
      }

      if (backdrop) backdrop.addEventListener('click', closeDrawer);
      if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && drawerRoot.classList.contains('is-open')) closeDrawer();
      });

      window.__leireSearchDrawerReady = true;
      document.addEventListener('leire:open-search', openDrawer);

      /* ---------- Estados ---------- */
      function showIdle() {
        if (idleBlock) idleBlock.hidden = false;
        if (live) live.hidden = true;
        if (ssrResults) ssrResults.hidden = true;
        renderHistory();
      }

      function showLive() {
        if (idleBlock) idleBlock.hidden = true;
        if (ssrResults) ssrResults.hidden = true;
        if (live) live.hidden = false;
      }

      function resetToIdle() {
        if (input) { input.value = ''; input.focus(); }
        currentQuery = '';
        showIdle();
      }

      if (clearTextBtn) clearTextBtn.addEventListener('click', resetToIdle);

      if (form) {
        form.addEventListener('submit', function() {
          if (input) saveTerm(input.value);
        });
      }

      /* ---------- Utilidades ---------- */
      function moneyFormat(cents) {
        const value = (cents / 100).toFixed(2).replace('.', ',');
        return value + '€';
      }

      function escapeHtml(str) {
        return String(str)
          .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
      }

      function renderProducts(products) {
        if (!liveProducts) return;

        if (products.length === 0) {
          liveProducts.innerHTML = '';
          if (liveFoot) liveFoot.hidden = true;
          return;
        }

        liveProducts.innerHTML = products.map(function(p) {
          const imgUrl = p.i ? p.i.replace(/\.(jpg|jpeg|png|webp)(\?.*)?$/i, '_400x.$1$2') : '';
          const hasCompare = p.c && p.c > p.p;

          let priceHtml = '';
          if (hasCompare) {
            priceHtml += '<span class="mb-product__price-was">' + moneyFormat(p.c) + '</span>';
          }
          priceHtml += '<span class="mb-product__price-now">' + moneyFormat(p.p) + '</span>';

          return '<a href="' + p.u + '" class="mb-product">'
            + '<div class="mb-product__media">'
            + (imgUrl ? '<img class="mb-product__img" src="' + imgUrl + '" alt="' + escapeHtml(p.t) + '" loading="lazy">' : '<div class="mb-product__placeholder"></div>')
            + '</div>'
            + '<div class="mb-product__body">'
            + '<h3 class="mb-product__title">' + escapeHtml(p.t) + '</h3>'
            + '<p class="mb-product__price">' + priceHtml + '</p>'
            + '</div>'
            + '</a>';
        }).join('');

        if (liveFoot && liveAll) {
          liveAll.href = '/search?q=' + encodeURIComponent(currentQuery) + '&type=product&options%5Bprefix%5D=last';
          liveFoot.hidden = false;
        }
      }

      if (liveProducts) {
        liveProducts.addEventListener('click', function() {
          if (input) saveTerm(input.value);
        });
      }
      if (liveAll) {
        liveAll.addEventListener('click', function() {
          if (input) saveTerm(input.value);
        });
      }

      async function handleInput() {
        const val = (input.value || '').trim();

        if (val.length === 0) { showIdle(); currentQuery = ''; return; }
        if (val === currentQuery) return;
        currentQuery = val;

        showLive();

        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(async function() {
          if (!catalogState.loaded) {
            if (loadingEl) loadingEl.hidden = false;
            if (liveEmpty) liveEmpty.hidden = true;
            await loadCatalog();
            if ((input.value || '').trim() !== val) return;
          }
          if (loadingEl) loadingEl.hidden = true;

          const results = searchCatalog(val, resultsLimit);
          renderProducts(results);
          if (liveEmpty) liveEmpty.hidden = results.length !== 0;
        }, 130);
      }

      if (input) {
        input.addEventListener('input', handleInput);
        input.addEventListener('keydown', function(e) {
          if (e.key === 'Escape') { e.stopPropagation(); resetToIdle(); }
        });
      }

      renderHistory();

      if (drawerRoot.classList.contains('is-open') && ssrResults) {
        if (idleBlock) idleBlock.hidden = true;
        if (!isMobileDrawer()) setSiblingsHidden(true);
        document.body.style.overflow = 'hidden';
        loadCatalog();
        startRotate();
      }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
